// eslint-disable-next-line import/no-cycle
import {
  WidgetTypeConfig,
  ConfigurationPanelStructureItemEnum,
  ComponentNameEnum,
  ElementPartTypeEnum,
  TemplateStructureEnum,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import getHorizontalSpacesFieldConfig from '@/components/template-builder/config/fields/horizontal-spaces-config';
// eslint-disable-next-line import/no-cycle
import getVerticalSpacesFieldConfig from '@/components/template-builder/config/fields/vertical-spaces-config';
// eslint-disable-next-line import/no-cycle
import {
  setCssProperty,
  setCssPropertyAndRemoveIfZero,
  setMediaDisplay,
} from '@/components/template-builder/setters';
// eslint-disable-next-line import/no-cycle
import {
  getClassByName,
  getCssPropertyByName,
  isMediaDisplayAlreadyRestricted,
} from '@/components/template-builder/getters';
// eslint-disable-next-line import/no-cycle
import mediaDisplayFieldConfig from '@/components/template-builder/config/fields/media-display-config';

// eslint-disable-next-line import/no-cycle
import getContent from '@/components/template-builder/getters/code';

// eslint-disable-next-line import/no-cycle
import setContent from '@/components/template-builder/setters/code';

// eslint-disable-next-line import/no-cycle
import getConditionsAndRepetitionGroup from '@/components/template-builder/config/fields/conditions-repetition-group-helper';
import bordersFieldConfig from '@/components/template-builder/config/fields/borders-config';
// eslint-disable-next-line import/no-cycle
import getCodeFieldConfig from '@/components/template-builder/config/fields/code-config';
// eslint-disable-next-line import/no-cycle
import getWidgetCommonStylesGroup from '@/components/template-builder/config/fields/widget-common-styles-config';
// eslint-disable-next-line import/no-cycle
import { getTemplateIframeDocument } from '@/components/template-builder/utils/helpers';
// eslint-disable-next-line import/no-cycle
import { HIDE_MOBILE_ATTRIBUTE } from '@/components/template-builder/utils/constants';
// eslint-disable-next-line import/no-cycle
import variables from '@/components/template-builder/utils/variables-list';

const widgetCodeConfig: WidgetTypeConfig = {
  tabPanel: {
    label: 'templateBuilder.widgetsHeaders.code',
    items: [
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.widgetConfiguration',
        selector: 'body #spm_body #{ID}',
        items: [
          {
            label: 'templateBuilder.fields.htmlCode',
            selector: '{SELECTOR}.spm_widget_code > tbody > tr > th, {SELECTOR}.spm_widget_display_code',
            properties: [{ name: 'content', getter: getContent, setters: [setContent] }],
            ...getCodeFieldConfig('', true, variables.allVariables, true),
          },
        ],
      },
      {
        type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
        tabItemType: TemplateStructureEnum.GROUP,
        label: 'templateBuilder.configs.widgetStyles',
        canSave: true,
        elementPartType: ElementPartTypeEnum.STYLES,
        tabPanel: {
          items: [
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.widgetBlockStyles',
              selector: 'body #spm_body #{ID}',
              items: [
                {
                  label: 'templateBuilder.fields.borders',
                  selector: '{SELECTOR}',
                  properties: [
                    { name: 'border-color', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-style', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-width', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
                    { name: 'border-bottom-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-bottom-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-bottom-width', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-top-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-top-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-top-width', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-left-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-left-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-left-width', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-right-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-right-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-right-width', getter: getCssPropertyByName, setters: [] },
                  ],
                  ...bordersFieldConfig,
                },
              ],
            },
            getWidgetCommonStylesGroup(),
          ],
        },
      },
      getConditionsAndRepetitionGroup('body #spm_body #{ID}'),
    ],
  },
};

export default widgetCodeConfig;
